import { createAsyncThunk } from "@reduxjs/toolkit"

import type { IOVPracticeConfigurationUpsertData } from "@common-shared/types/requestData/oneVerifyRequestData.types"
import type { IPractice } from "@common-shared/types/responseData/commonResponseData.types"

import { PracticeConfigurationsService } from "../../services/practiceConfigurations.service"
import type {
    IThunkActionData,
    IThunkActionWithPracticeData,
} from "../../types/general.types"
import {
    runtimeStartLoading,
    runtimeStopLoading,
} from "../slices/runtime.slice"
import { userDetailsSetSelectedPracticeConfiguration } from "../slices/userDetails.slice"

/**
 * Get practice configuration.
 */
export const practiceConfigurationsGet = createAsyncThunk<
    void,
    IThunkActionData<IPractice>
>("practiceConfigurationsGetPrefix", async (action, { dispatch }) => {
    dispatch(runtimeStartLoading("practiceConfigurationsGetLoading"))

    try {
        const result =
            await PracticeConfigurationsService.getPracticeConfiguration(
                action.payload,
            )

        if (result) {
            dispatch(userDetailsSetSelectedPracticeConfiguration(result))

            action.onSuccess?.(result)
        } else {
            action.onError?.(result)
        }
    } catch (e) {
    } finally {
        dispatch(runtimeStopLoading("practiceConfigurationsGetLoading"))

        action.onFinally?.()
    }
})

/**
 * Upsert practice configuration.
 */
export const practiceConfigurationsUpsert = createAsyncThunk<
    void,
    IThunkActionWithPracticeData<
        Pick<IOVPracticeConfigurationUpsertData, "payerMappingsMode">
    >
>("practiceConfigurationsUpsertPrefix", async (action, { dispatch }) => {
    dispatch(runtimeStartLoading("practiceConfigurationsUpsertLoading"))

    try {
        const result =
            await PracticeConfigurationsService.upsertPracticeConfiguration(
                action.practice,
                action.payload,
            )

        if (result) {
            dispatch(userDetailsSetSelectedPracticeConfiguration(result))

            action.onSuccess?.(result)
        } else {
            action.onError?.(result)
        }
    } catch (e) {
    } finally {
        dispatch(runtimeStopLoading("practiceConfigurationsUpsertLoading"))

        action.onFinally?.()
    }
})
